import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IAllTemplatePoliciesResponse extends DefaultResponseWithData<ITemplatePolicy[]> { }

export interface ITemplatePolicy extends BaseEntity {
  type: TemplatePolicyType;
  description: string;
  createdBy?: string;
  updatedBy?: string;
  deleted?: string;
  deletedBy?: string;
}

export enum TemplatePolicyType {
  Warranty,
  TermsAndConditions,
  Returns,
}

export interface ICreateUpdateTemplatePolicyRequest {
  type: TemplatePolicyType;
  description: string;
}

